// @generated by protoc-gen-connect-es v1.3.0
// @generated from file proctoring/v1/session.proto (package proctoring.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { SessionServiceEndRequest, SessionServiceEndResponse, SessionServiceFindInfoRequest, SessionServiceFindInfoResponse, SessionServiceFindRequest, SessionServiceFindResponse, SessionServiceGetInfoRequest, SessionServiceGetInfoResponse, SessionServiceGetRequest, SessionServiceGetResponse, SessionServiceNewRequest, SessionServiceNewResponse, SessionServiceUpdateInfoRequest, SessionServiceUpdateInfoResponse } from "./session_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service proctoring.v1.SessionService
 */
export const SessionService = {
  typeName: "proctoring.v1.SessionService",
  methods: {
    /**
     * @generated from rpc proctoring.v1.SessionService.New
     */
    new: {
      name: "New",
      I: SessionServiceNewRequest,
      O: SessionServiceNewResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc proctoring.v1.SessionService.End
     */
    end: {
      name: "End",
      I: SessionServiceEndRequest,
      O: SessionServiceEndResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc proctoring.v1.SessionService.Get
     */
    get: {
      name: "Get",
      I: SessionServiceGetRequest,
      O: SessionServiceGetResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc proctoring.v1.SessionService.Find
     */
    find: {
      name: "Find",
      I: SessionServiceFindRequest,
      O: SessionServiceFindResponse,
      kind: MethodKind.ServerStreaming,
    },
    /**
     * @generated from rpc proctoring.v1.SessionService.GetInfo
     */
    getInfo: {
      name: "GetInfo",
      I: SessionServiceGetInfoRequest,
      O: SessionServiceGetInfoResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc proctoring.v1.SessionService.FindInfo
     */
    findInfo: {
      name: "FindInfo",
      I: SessionServiceFindInfoRequest,
      O: SessionServiceFindInfoResponse,
      kind: MethodKind.ServerStreaming,
    },
    /**
     * temporary hack until all events are migrated
     *
     * @generated from rpc proctoring.v1.SessionService.UpdateInfo
     */
    updateInfo: {
      name: "UpdateInfo",
      I: SessionServiceUpdateInfoRequest,
      O: SessionServiceUpdateInfoResponse,
      kind: MethodKind.Unary,
    },
  }
};

